
const ls = require('local-storage')

class PhotoServices {
  getPhotoStudent (matricula) {
    try {
      return `${ls.get('urlFoto')}readphotoBySigla/` + matricula + '.png/' + ls.get('sigla')
    } catch (error) {
      return error
    }
  }

  getPhotoUser (username) {
    try {
      const timestamp = new Date().getTime();
      // return `${ls.get('urlFoto')}readphotoByUsername/` + username + '.png/' + ls.get('sigla')
      return `${ls.get('urlFoto')}readphotoByUsername/${username}.png/${ls.get('sigla')}?t=${timestamp}`;
    } catch (error) {
      return error
    }
  }
  getPhotoComprovativo (username) {
    try {
      return `${ls.get('urlFoto')}readphotoByComprovativo/` + username.replaceAll('/', '')
    } catch (error) {
      return error
    }
  }
}
export default new PhotoServices()
